import styled from 'styled-components';

export const TextArea = styled.textarea<{ isPunchup?: boolean }>`
	resize: none;
	width: 100%;
	min-height: 100px;
	padding: 12px;
	box-sizing: border-box;
	background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.blackGrey3)};
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	border: ${({ isPunchup }) => (isPunchup ? '1px solid #e5e5e5' : 'none')};
	font-family: ${({ theme }) => theme.fonts.primary};
	font-size: 16px;
	border-radius: 2px;

	&:focus {
		outline: 0;
		border: ${({ theme, isPunchup }) => (isPunchup ? '1px solid #fe5e25' : `0.5px solid ${theme.colors.lightGrey4}`)};
	}
`;

export const InputContainer = styled.div<{ hasError?: boolean; isPunchup?: boolean }>`
	margin-top: ${({ hasError }) => hasError && '4px'};
	width: 100%;

	${({ hasError, theme }) =>
		hasError &&
		`
		${TextArea} {
			border: 0.5px solid ${theme.colors.red};
		}
	`}
`;
